import { render } from "./AI_Caution.vue?vue&type=template&id=2342fe0f&scoped=true"
import script from "./AI_Caution.vue?vue&type=script&lang=js"
export * from "./AI_Caution.vue?vue&type=script&lang=js"

import "./AI_Caution.vue?vue&type=style&index=0&id=2342fe0f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2342fe0f"]])

export default __exports__